(function() {
	/**
	 * Renders project detail: Project Item
	 * @param {Object} props - Page context and properties
	 * @returns {object} Promise object
	 */
	WebBaseAprovLV.renderProjectPage = function(props) {
		var params = {
			page: props.context.params.page || '',
			detail: props.context.params.detail || ''
		};
		var model = {
			element: null,
			template: 'templates/project.ejs.html?v=' + WebBaseAprovLV.version.template,
			data: {
				main: (props.context.Model || {}).Main || {}, /* Comes from renderMainContent() */
				pageRaw: null,
				navRaw: null,
				projectRaw: null,
				nav: null,
				pageContent: null
			}
		};
		return $.when(
			// WebBaseAprovLV.Utils.getKKData('?system.type=page&system.codename[in]=news'),
			WebBaseAprovLV.Utils.getKKData('?system.type=page&elements.url[in]=' + params.page + '&depth=1'),
			WebBaseAprovLV.Utils.getKKData('?system.type=project_item&elements.url[in]=' + params.detail + '&depth=2'),
			ejs.preloadTemplate(model.template),
			ejs.preloadTemplate('templates/breadcrumb.ejs.html?v=' + WebBaseAprovLV.version.template),
			ejs.preloadTemplate('templates/bottomnav.ejs.html?v=' + WebBaseAprovLV.version.template)
		).then(function(pageXhr, projectXhr, tmplPage, tmplBreadcrumb, tmplBottomnav) {
			var pageRaw = Array.isArray(pageXhr) && pageXhr.length ? pageXhr[0] : (pageXhr || {});
			var projectRaw = Array.isArray(projectXhr) && projectXhr.length ? projectXhr[0] : (projectXhr || {});
			model.data.navRaw = {};
			model.data.pageRaw = pageRaw;
			model.data.projectRaw = projectRaw;
			model.element = $('#content');
			model.data = $.extend(model.data, {
				pageContent: WebBaseAprovLV.Utils.getKKViewModel(model.data.pageRaw)[0] || {},
				nav: WebBaseAprovLV.Utils.getKKViewModel(model.data.navRaw)[0] || {},
				project: WebBaseAprovLV.Utils.getKKViewModel(model.data.projectRaw)[0] || {}
			});
			return WebBaseAprovLV.Utils.transitionTo(model);
		}).promise();
	};
})();
